import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import outdoorIt from '../static/images/outdoor_advices/outdoor_it.png'
import outdoorEn from '../static/images/outdoor_advices/outdoor_en.png'
import outdoorFr from '../static/images/outdoor_advices/outdoor_fr.png'
import outdoorDe from '../static/images/outdoor_advices/outdoor_de.png'
import { useTranslation } from 'react-i18next'

export default function OutdoorAdvices() {
  const { t, i18n } = useTranslation();
  const [image, setImage] = useState<string | null>(null);
  useEffect(() => {
    switch (i18n.language) {
      case 'it':
        setImage(outdoorIt);
        break;
      case 'en':
        setImage(outdoorEn);
        break;
      case 'fr':
        setImage(outdoorFr);
        break;
      case 'de':
        setImage(outdoorDe);
        break;
      default:
        setImage(outdoorIt);
    }
  }, [i18n.language]);

  return (

    <div className="my-8 w-full lg:w-[1000px] h-[400px] md:h-[900px] rounded-xl mt-4 flex flex-col justify-end items-center relative bg-cover bg-center" style={{ backgroundImage: `url(${image})` }}>
      <div className='w-full flex flex-col items-center text-center gap-2 mb-8 px-4'>
        <div className="flex items-center">
          <div className='text-white text-sm md:text-2xl whitespace-nowrap'>{t('OutdoorAdviceSection.discoverOur')}</div>
          <div className='font-signature text-[#b05704] text-3xl md:text-7xl md:mb-4 mx-2 md:mx-4'>{t('OutdoorAdviceSection.column')}</div>
          <div className='text-white text-sm md:text-2xl whitespace-nowrap'>{t('OutdoorAdviceSection.ofExpertAdvices')}</div>
        </div>

        <Link to="https://youtube.com/playlist?list=PLDR2Ge9T7lOk4EVwMKPE4IdS2ig_jcWvC&si=NarkuyRvvNxFjSqA"><button className='py-2 px-4 bg-[#fbd100] rounded-xl text-white'>{t('OutdoorAdviceSection.linkButton')}</button></Link>
      </div>
    </div>

  )
}
